import moment from 'moment'
moment.locale('zh-cn')

export default {
    install: function(Vue) {
        Vue.$moment = moment
        Object.defineProperty(Vue.prototype, '$moment', {
            value: moment
        })
    }
}